module.exports = __webpack_public_path__ + "static/img/linkage-edit.13a8d750.svg";